(function () {
  function contentText(key) {
    var source = document.querySelector("[data-bcw-interface-text]");
    return source ? source.getAttribute("data-" + key) || "" : "";
  }

  function updateCartCount(itemCount) {
    var cartLink = document.querySelector(".bcw-header__cart-link");
    if (!cartLink) return;

    var count = cartLink.querySelector(".bcw-header__cart-count");
    if (!count && itemCount > 0) {
      count = document.createElement("span");
      count.className = "bcw-header__cart-count";
      count.setAttribute("aria-hidden", "true");
      cartLink.appendChild(count);
    }

    if (count) count.textContent = String(itemCount);
    if (count) count.hidden = itemCount < 1;
    cartLink.setAttribute("aria-label", contentText("cart") + (itemCount > 0 ? ", " + itemCount + " " + contentText("items") : ""));
  }

  function submitCartForm(form) {
    var button = form.querySelector("[data-bcw-quick-add-button], [data-bcw-add-to-cart]");
    var label = form.querySelector("[data-bcw-button-label]");
    var message = form.querySelector("[data-bcw-form-message]");
    var originalLabel = label ? label.textContent : "";

    if (button) button.disabled = true;
    if (label) label.textContent = contentText("adding");
    if (message) message.textContent = "";

    var shopRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

    return fetch(shopRoot + "cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: new FormData(form)
    })
      .then(function (response) {
        if (!response.ok) return response.json().then(function (error) { throw error; });
        return fetch(shopRoot + "cart.js", { headers: { Accept: "application/json" } });
      })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (label) label.textContent = contentText("added");
        if (message) message.textContent = contentText("added-message");
      })
      .catch(function (error) {
        if (label) label.textContent = originalLabel;
        if (message) message.textContent = error.description || contentText("add-error");
      })
      .finally(function () {
        window.setTimeout(function () {
          if (button) button.disabled = false;
          if (label && label.textContent === contentText("added")) label.textContent = originalLabel;
        }, 1600);
      });
  }

  function initQuickAdd(scope) {
    scope.querySelectorAll("[data-bcw-quick-add-form]").forEach(function (form) {
      if (form.dataset.bcwReady) return;
      form.dataset.bcwReady = "true";
      form.addEventListener("submit", function (event) {
        event.preventDefault();
        submitCartForm(form);
      });
    });
  }

  function initProduct(root) {
    if (root.dataset.bcwReady) return;
    root.dataset.bcwReady = "true";

    var form = root.querySelector("[data-bcw-product-form]");
    var select = root.querySelector("[data-bcw-variant-select]");
    var json = root.querySelector("[data-bcw-product-json]");
    var variants = json ? JSON.parse(json.textContent) : [];
    var price = root.querySelector("[data-bcw-product-price]");
    var status = root.querySelector("[data-bcw-product-status]");
    var submit = root.querySelector("[data-bcw-add-to-cart]");
    var submitLabel = submit ? submit.querySelector("[data-bcw-button-label]") : null;
    var grandOpening = root.querySelector("[data-bcw-grand-opening]");
    var grandOpeningEligible = root.dataset.bcwGrandOpeningEligible === "true";

    function money(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === "function") return window.Shopify.formatMoney(cents);
      return new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "USD" }).format(cents / 100);
    }

    function updateVariant() {
      var variant = variants.find(function (item) { return String(item.id) === select.value; });
      if (!variant) return;
      price.innerHTML = "<span>" + money(variant.price) + "</span>" + (variant.compare_at_price > variant.price ? " <s>" + money(variant.compare_at_price) + "</s>" : "");
      if (grandOpening) {
        grandOpening.hidden = !(grandOpeningEligible && variant.compare_at_price > variant.price && variant.compare_at_price === variant.price * 2);
      }
      status.textContent = variant.available ? contentText("available") : contentText("unavailable");
      submit.disabled = !variant.available;
      submitLabel.textContent = variant.available ? contentText("add-to-cart") : contentText("sold-out");
      window.history.replaceState({}, "", window.location.pathname + "?variant=" + variant.id);
    }

    if (select) select.addEventListener("change", updateVariant);

    root.querySelectorAll("[data-bcw-quantity-change]").forEach(function (control) {
      control.addEventListener("click", function () {
        var input = root.querySelector("[data-bcw-quantity-input]");
        input.value = String(Math.max(1, Number(input.value || 1) + Number(control.dataset.bcwQuantityChange)));
      });
    });

    root.querySelectorAll("[data-bcw-gallery-thumb]").forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        var selectedId = thumb.dataset.mediaId;
        root.querySelectorAll("[data-bcw-gallery-item]").forEach(function (item) {
          var activeItem = item.dataset.mediaId === selectedId;
          item.hidden = !activeItem;
          if (!activeItem) {
            var video = item.querySelector("video");
            if (video) video.pause();
          }
        });
        root.querySelectorAll("[data-bcw-gallery-thumb]").forEach(function (item) {
          var active = item === thumb;
          item.classList.toggle("is-active", active);
          item.setAttribute("aria-pressed", String(active));
        });
      });
    });

    if (form) form.addEventListener("submit", function (event) {
      if (event.submitter && !event.submitter.matches("[data-bcw-add-to-cart]")) return;
      event.preventDefault();
      submitCartForm(form);
    });
  }

  function initCart(root) {
    if (root.dataset.bcwReady) return;
    root.dataset.bcwReady = "true";

    root.addEventListener("click", function (event) {
      var control = event.target.closest("[data-bcw-cart-quantity-decrease], [data-bcw-cart-quantity-increase]");
      if (!control || !root.contains(control)) return;

      var quantity = control.closest("[data-bcw-cart-quantity]");
      var input = quantity ? quantity.querySelector("[data-bcw-cart-quantity-input]") : null;
      if (!input) return;

      var minimum = Number(input.min) || 1;
      var currentValue = input.valueAsNumber;
      if (!Number.isFinite(currentValue)) currentValue = minimum;

      if (control.matches("[data-bcw-cart-quantity-decrease]")) {
        input.value = String(Math.max(minimum, currentValue - 1));
      } else {
        input.value = String(currentValue + 1);
      }

      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  function initCommerce(scope) {
    initQuickAdd(scope);
    scope.querySelectorAll("[data-bcw-product-root]").forEach(initProduct);
    scope.querySelectorAll("[data-bcw-cart-root]").forEach(initCart);
    scope.querySelectorAll("[data-bcw-sort-select]").forEach(function (select) {
      if (select.dataset.bcwReady) return;
      select.dataset.bcwReady = "true";
      select.addEventListener("change", function () { select.form.submit(); });
    });
  }

  function ready() { initCommerce(document); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ready); else ready();
  document.addEventListener("shopify:section:load", function (event) { initCommerce(event.target); });
})();
